import {
  FormValidatorContext,
  validateTimeframeDates,
  validateTimeframeUtmTestId
} from './validate-timeframe';
import {
  validateRulesMinimum,
  validateRulesMaximum,
  validateTimezone,
  validateCustomRetention,
  validateUtmTestId,
  validateDefaultUrl,
  validatePloverUrl,
  validateFolderPath,
  validateDomain,
  validateVariantsField,
  validateDefaultId,
  validateGenericField
} from './validate-basic-route-fields';
import { validateArrayField } from './validate-array-fields';

type formFieldMappingObj = Record<string, string>;

export const formValidator = (
  formObj: any,
  validationArray: string | any[],
  bulkPlover: any,
  optionalObject?: FormValidatorContext
): any[] => {
  const formFieldMappingObj: formFieldMappingObj = {
    test_name: bulkPlover.isBulkPlover ? 'route_name' : 'Route Name',
    utm_test_id: bulkPlover.isBulkPlover
      ? 'utm_exp & utm_test & version number'
      : 'Route Tracking URL Parameter',
    default_url: bulkPlover.isBulkPlover ? 'default_url' : 'Fallback Variant URL',
    default_id: bulkPlover.isBulkPlover ? 'default_id' : 'Fallback Variant ID',
    domain: 'Domain',
    plover_url: bulkPlover.isBulkPlover ? 'plover_url' : 'Plover Name',
    folder_path: bulkPlover.isBulkPlover ? 'folder_path' : 'Path',
    notes: 'Notes',
    variant_id: bulkPlover.isBulkPlover ? 'variant name' : 'Variant ID',
    variant_url: 'Variant URL',
    variant_split: 'Variant Split',
    rule_name: 'Rule Name',
    trigger: 'Trigger',
    rule: '"Select Rule"',
    value: 'Value',
    condition: 'Condition',
    operator: 'Operator',
    additional_utm: 'Additional UTMs',
    cookie_operation: 'Cookie Operation',
    day: 'Day of the Week',
    reset: 'Reset Variant Retention'
  };

  const splitTotalArray: any = [];
  const invalidationArray: any[] = [];

  let stopped = false;
  for (let i = 0; i < validationArray.length && !stopped; i++) {
    switch (validationArray[i]) {
      case 'rules-minimum':
        validateRulesMinimum(formObj, invalidationArray);
        break;
      case 'rules-maximum':
        validateRulesMaximum(formObj, invalidationArray);
        break;
      case 'timeframe_dates':
        validateTimeframeDates(formObj, invalidationArray);
        break;
      case 'timeframe_utm_test_id':
        validateTimeframeUtmTestId(formObj, invalidationArray, optionalObject);
        break;
      case 'timezone':
        validateTimezone(formObj, invalidationArray);
        break;
      case 'customRetention':
        validateCustomRetention(formObj, invalidationArray);
        break;
      default:
        switch (typeof formObj[validationArray[i]]) {
          case 'object':
            if (Array.isArray(formObj[validationArray[i]])) {
              const shouldStop = validateArrayField(
                formObj,
                validationArray,
                i,
                bulkPlover,
                formFieldMappingObj,
                splitTotalArray,
                invalidationArray
              );
              if (shouldStop) {
                stopped = true;
              }
            }
            break;
          default:
            switch (validationArray[i]) {
              case 'utm_test_id':
                validateUtmTestId(formObj, bulkPlover, formFieldMappingObj, invalidationArray);
                break;
              case 'default_url':
                validateDefaultUrl(formObj, bulkPlover, formFieldMappingObj, invalidationArray);
                break;
              case 'plover_url':
                validatePloverUrl(formObj, bulkPlover, formFieldMappingObj, invalidationArray);
                break;
              case 'folder_path':
                validateFolderPath(formObj, bulkPlover, formFieldMappingObj, invalidationArray);
                break;
              case 'domain':
                validateDomain(formObj, bulkPlover, formFieldMappingObj, invalidationArray);
                break;
              case 'variants':
                validateVariantsField(formObj, bulkPlover, formFieldMappingObj, invalidationArray);
                break;
              case 'default_id':
                validateDefaultId(formObj, bulkPlover, formFieldMappingObj, invalidationArray);
                break;
              default:
                validateGenericField(
                  formObj,
                  validationArray[i],
                  bulkPlover,
                  formFieldMappingObj,
                  invalidationArray
                );
            }
        }
    }
  }

  return invalidationArray;
};
